const BeforeAfterCard = ({ label, title, items, variant }) => {
  const isBefore = variant === "before";
  return (
    <div
      className={`
        flex flex-col items-start md:p-10 p-6 w-full md:flex-1 text-white justify-end
        ${isBefore ? "bg-black" : "bg-green-01"}
        ${isBefore ? "md:rounded-l-[16px]" : "md:rounded-r-[16px]"}
      `}
    >
      <div
        className={`flex flex-col items-start gap-6  ${!isBefore ? "-mt-5" : ""} self-stretch md:gap-8`}
      >
        <div
          className={`
    flex py-0.5 px-2.5 md:px-3 justify-center items-center gap-2.5 rounded-xl 
    bg-navy-blue-03 text-white text-[10px] leading-[20px] 
    md:text-[12px] md:leading-[22px] font-medium
    // ${isBefore ? "visible" : "invisible"}
    ${!isBefore ? "md:mt-5 mt-0" : ""}
  `}
        >
          <span className="text-[12px] font-google">{label}</span>
        </div>
        {/* Title */}
        <p
          className={`self-stretch font-inter ${isBefore ? "text-red" : "text-green"}  text-[20px] leading-[28px] md:text-[24px] md:leading-[32px] font-medium`}
        >
          {title}
        </p>

        {/* Items */}
        <div className="flex flex-col gap-6">
          {items.map((item, index) => (
            <div key={index}>
              <p className="text-white text-[28px] font-google leading-[36px] md:text-[36px] md:leading-[44px] font-medium">
                {item.value}
              </p>
              <p
                className={` text-[18px] font-inter leading-[26px] md:text-[20px] md:leading-[28px] font-medium ${isBefore ? "text-grey-04" : "text-grey-02"}`}
              >
                {item.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default BeforeAfterCard;
